export default __webpack_public_path__ + "static/media/WMCJ-15190.ee9f1b32.jpg";